"use strict";

var _interopRequireWildcard = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.to-string.js");
var $wl = _interopRequireWildcard(require("@/utils/wl-utils"));
function _default(el /* , binding, vnode, oldVnode */) {
  if (el.getAttribute('dialog-tool-max') !== null) return;
  if (el.className.indexOf('el-dialog__wrapper') === -1) return;
  // 主体
  var a = el === null || el === void 0 ? void 0 : el.querySelector('.el-dialog');
  // 对话框头部
  var b = a === null || a === void 0 ? void 0 : a.querySelector('.el-dialog__header');
  if (!a || !b) return;
  if (b.querySelector('[aria-label=dialog-max]')) return;

  /* 创建按钮 */
  var c = document.createElement('button');
  /* 设置按钮样式 */
  c.className = 'el-dialog__headerbtn';
  c.setAttribute('title', '全屏');
  c.setAttribute('aria-label', 'dialog-max');
  c.style.cssText += ";color: #909399;";
  // 插入元素
  b.insertBefore(c, b.querySelector('[aria-label="Close"]'));

  /* 创建图标 */
  // console.log(b.sheet.addRule(''))
  var ca = document.createElement('div');
  var cb = document.createElement('div');
  var cc = document.createElement('div');
  c.append(ca);
  ca.append(cb);
  ca.append(cc);
  var w = 0.8;
  var h = 0.8;
  var style = ";position: absolute;width: ".concat(h, "em;height: ").concat(h, "em;border: 1.5px solid #909399;border-radius: 0.2em;background: #fff9;");
  var cbf = function cbf(status) {
    return ";bottom: ".concat(status ? (1 - h) / 2 : 0, "em;left: ").concat(status ? (1 - w) / 2 : 0, "em;");
  };
  var ccf = function ccf(status) {
    return ";top: ".concat(status ? (1 - h) / 2 : 0, "em;right: ").concat(status ? (1 - w) / 2 : 0, "em;");
  };
  ca.style.cssText += ";position: relative;width: 1em; height: 1em;";
  cb.style.cssText += ";".concat(style, ";").concat(cbf(false), ";z-index: 1;");
  cc.style.cssText += ";".concat(style, ";").concat(ccf(false), ";z-index: 0;");
  c.onclick = function () {
    var r1 = document.body.clientWidth * 0.98 < a.offsetWidth;
    var r2 = document.body.clientHeight * 0.98 < a.offsetHeight;

    /* 全屏状态 */
    if (r1 && r2) {
      c.setAttribute('title', '全屏');
      cb.style.cssText += ";".concat(cbf(false), ";");
      cc.style.cssText += ";".concat(ccf(false), ";");
      a.style.cssText += ";".concat(a.getAttribute('dialog-size'), ";").concat(a.getAttribute('dialog-location'), ";");
      var hv = el.clientHeight - $wl.getDomSize(el, 'padding-top') - $wl.getDomSize(el, 'padding-bottom');
      var wv = el.clientWidth - $wl.getDomSize(el, 'padding-left') - $wl.getDomSize(el, 'padding-right');
      a.style.cssText += ";max-width: ".concat(wv, "px;max-height: ").concat(hv, "px;");
    } else {
      c.setAttribute('title', '缩小');
      a.setAttribute('dialog-size', ['width', 'height'].map(function (k) {
        return ";".concat(k, ": ").concat($wl.getDomSize(a, k), "px;");
      }).join(''));
      a.setAttribute('dialog-location', ['top', 'left'].map(function (k) {
        return ";".concat(k, ": ").concat($wl.getDomSize(a, k), "px;");
      }).join(''));
      cb.style.cssText += ";".concat(cbf(true), ";");
      cc.style.cssText += ";".concat(ccf(true), ";");
      a.style.cssText += ";top: 0;left: 0;width: 100%;height: 100%;";
      a.style.cssText += ";max-width: 100%;max-height: 100%;";
    }
  };
  el.setAttribute('dialog-tool-max', '');
}